<template>
  <div class="placeholder embed-responsive embed-responsive-16by9">
    <div class="placeholder__wrap embed-responsive-item">
      <div class="placeholder__content">
        <slot />
      </div>

      <div class="placeholder__background" :style="{ backgroundImage: `url(${courseModuleClass.original_thumb})` }">
        <div class="placeholder__overlay"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters('course', ['courseModuleClass'])
  }
}
</script>

<style lang="scss" scoped>
  .placeholder {
    border-radius: 16px;

    &__wrap {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__content {
      position: relative;
      z-index: 2;
    }

    &__background {
      position: absolute;
      display: flex;
      align-items: stretch;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center center;
      filter: blur(10px);
    }
  
    &__overlay {
      flex: 1;
      opacity: .8;
      background: #000;
    }
  }
</style>